import { SortOptionField } from "../../../../../Common/Button/SortChooser"
import { APIAppInstanceModel } from "../../../../../../Models/API/AppInstanceModel"

export const appSortOptions: SortOptionField<APIAppInstanceModel>[] = [
    {
        field: "name",
        label: "Name",
        ascLabel: "Lowest first",
        descLabel: "Highest first"
    },
    {
        field: "uuid",
        label: "ID",
        ascLabel: "Ascending",
        descLabel: "Descending"
    },
    {
        field: "created",
        label: "Created",
        ascLabel: "Oldest first",
        descLabel: "Youngest first"
    },
    {
        field: "status",
        label: "Status",
        ascLabel: "Completed last",
        descLabel: "Completed first"
    },
    {
        field: "templateName",
        label: "Project type",
        ascLabel: "Lowest first",
        descLabel: "Highest first"
    }
]
